import {
  Children,
  cloneElement,
  Fragment,
  type ReactElement,
  type ReactNode,
} from 'react'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

const useStyles = makeStyles(
  (theme) => ({
    button: {
      color: theme.colors.secondaryText,
      fontWeight: 400,
      fontSize: '1.4rem',
      textTransform: 'none',
      textDecoration: 'underline',
      '&:not(:last-child)': {
        marginRight: theme.spacing(1),
      },
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  }),
  { name: 'TopMenuButtonsSection' },
)

export interface TopMenuButtonsSectionProps {
  children: ReactNode
  className?: string
}

const TopMenuButtonsSection = ({
  children,
  className,
}: TopMenuButtonsSectionProps) => {
  const classes = useStyles()

  const childrenArray = Children.toArray(children) as ReactElement[]

  return (
    <>
      {childrenArray.map((child, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          {cloneElement(child, {
            className: classNames(classes.button, className),
          })}
        </Fragment>
      ))}
    </>
  )
}

export default TopMenuButtonsSection
